import React, { Fragment, FC } from "react";
import { NavLink, Link } from "react-router-dom";
import { logout } from "../../../store/actions/auth";
import { connect } from "react-redux";
import { RootState } from "../../../store/reducers";
import { User } from "../../../models/user";
import { setTheme } from "../../../store/actions";
import UserLink from "../../../utils/UserLink";

const UserInfo: FC<{
  logout: Function;
  user: User;
  setTheme: Function;
  lightTheme: boolean;
  isAuthenticated: boolean;
}> = ({ logout, user, lightTheme, setTheme, isAuthenticated }) => {
  return (
    <div
      data-uk-dropdown="pos: bottom-left; delay-hide: 100"
      className=" uk-border-rounded uk-width-small"
      id="acc-dropdown"
    >
      <ul className="uk-nav uk-dropdown-nav">
        {isAuthenticated && (
          <Fragment>
            <li className="uk-nav-header">{user.username}</li>
            <li>
              <NavLink to="/account" className="dcl">
                <i className="material-icons-outlined md-24">account_circle</i>
                <span>Account</span>
              </NavLink>
            </li>
            <li className="dcl">
              <UserLink params={{ username: user.username }}>
                <i className="material-icons-outlined md-24">person</i>
                <span>Profile</span>
              </UserLink>
            </li>

            {user.accountType === `artist` && (
              <>
                <li>
                  <NavLink to="/dashboard" className="dcl">
                    <i className="material-icons-outlined md-24">dashboard</i>
                    <span>Dashboard</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="#"
                    uk-toggle="target: #create-modal"
                    className="dcl"
                  >
                    <i className="material-icons-outlined md-24">add</i>{" "}
                    <span>Create</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="#"
                    uk-toggle="target: #uploads-modal"
                    className="dcl"
                  >
                    <i className="material-icons-outlined md-24">backup</i>{" "}
                    <span>Uploads</span>
                  </NavLink>
                </li>
              </>
            )}
          </Fragment>
        )}

        <li>
          <a
            href="#!"
            className="toggle dcl"
            onClick={(e) => {
              e.preventDefault();
              // console.log("object")
              setTheme(!lightTheme);
            }}
          >
            <span>
              {lightTheme ? (
                <i
                  style={{ color: "red" }}
                  className="material-icons-outlined md-24"
                >
                  toggle_off
                </i>
              ) : (
                <i
                  style={{ color: "green" }}
                  className="material-icons-outlined md-24"
                >
                  toggle_on
                </i>
              )}
            </span>
            <span>Dark mode</span>
          </a>
        </li>
        <li className="uk-nav-divider"></li>
        {isAuthenticated ? (
          <li>
            <Link to="/login" className="dcl" onClick={() => logout()}>
              <i className="material-icons">power_settings_new</i>
              <span>Logout</span>
            </Link>
          </li>
        ) : (
          <li>
            <Link to="/login" className="dcl" onClick={() => logout()}>
              <i className="material-icons">label_important</i>
              <span>Sign in</span>
            </Link>
          </li>
        )}
      </ul>
    </div>
  );
};

const mapStatoProps = (state: RootState) => ({
  user: state.auth.user,
  isAuthenticated: state.auth.isAuthenticated,
  lightTheme: state.data.lightTheme,
});

export default connect(mapStatoProps, { logout, setTheme })(UserInfo);
